import { ChangeDetectionStrategy, Component, effect, inject, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SnackbarService } from '@comparit/core';
import { ApiAction } from '@comparit/shared';
import type { MarkedItem } from '@comparit/shared';
import { VergleichBaseService } from '../../services/vergleich-base.service';

@Component({
  selector: 'ui-download-pdf-button',
  templateUrl: './download-pdf-button.component.html',
  styleUrl: './download-pdf-button.component.scss',
  imports: [MatIcon, MatProgressSpinnerModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'contents' },
})
export class DownloadPdfButtonComponent {
  private readonly vergleich = inject(VergleichBaseService);
  private readonly snackbar = inject(SnackbarService);

  readonly kombinationen = input.required<MarkedItem[]>();
  readonly leistungstexteAnzeigen = input(false);
  readonly nurUnterschiede = input(false);

  protected readonly download = new ApiAction();

  constructor() {
    effect(() => {
      const error = this.download.error();
      if (error) this.snackbar.error(error);
    });
  }

  protected downloadPdf(): void {
    this.download.execute(
      this.vergleich.downloadPdf$(this.kombinationen(), {
        leistungstexteAnzeigen: this.leistungstexteAnzeigen(),
        nurUnterschiede: this.nurUnterschiede(),
      }),
      () => 'PDF konnte nicht erstellt werden.'
    );
  }
}
